"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const card_container_1 = __importDefault(require("../CardContainer/card-container"));
const provider_components_1 = require("@kyruus/provider-components");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const AlternateProviders = ({ altProviders = [], createAvailabilityUrl, createProviderUrl, track }) => {
    return (react_1.default.createElement(card_container_1.default, null,
        react_1.default.createElement(styles_1.AltProvidersHeader, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.altProvidersHeader))),
        react_1.default.createElement(styles_1.AltProvidersCards, { createAvailabilityUrl: createAvailabilityUrl, createProviderUrl: createProviderUrl, providers: altProviders, track: track, renderType: provider_components_1.SIMILAR_PROVIDERS })));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(AlternateProviders);
//# sourceMappingURL=alternate-providers.js.map